import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import useTimer from "@/shared/hooks/useTimer";
import { useRouter } from "next/navigation";

export default function FlightCounterTimer() {
  const router = useRouter();
  const { formattedTime, isFinished } = useTimer(900);

  //   TODO: Change it later
  if (isFinished) router.back();

  return (
    <Flex className="w-14 bg-success-20 rounded-xs justify-center items-center py-1">
      <Typography variant="h6" className="font-medium text-success-80">
        {formattedTime}
      </Typography>
    </Flex>
  );
}
